import type { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/**
 * Full-screen sheet (phone) — Cancel · title · trailing; body scrolls;
 * optional footer for destructive only — plan/35.
 */
export function AppSheet(props: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  children: ReactNode;
  /** Trailing header control (Approve / Done). */
  trailing?: ReactNode;
  /** Dismiss label — default Cancel. */
  dismissLabel?: string;
  /** Bottom chrome — destructive actions only. */
  footer?: ReactNode;
}) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent className="fixed inset-0 left-0 top-0 z-50 flex h-dvh max-h-dvh w-full max-w-none translate-x-0 translate-y-0 flex-col gap-0 rounded-none border-0 p-0 shadow-none">
        <div className="flex shrink-0 items-center gap-2 border-b border-[var(--color-border)] px-3 py-2.5 pt-[max(0.625rem,env(safe-area-inset-top))]">
          <Button
            type="button"
            variant="ghost"
            className="min-h-11 shrink-0"
            onClick={() => props.onOpenChange(false)}
          >
            {props.dismissLabel ?? "Cancel"}
          </Button>
          <div className="min-w-0 flex-1 text-center">
            <DialogTitle className="text-base">{props.title}</DialogTitle>
            <DialogDescription className="sr-only">
              {props.description}
            </DialogDescription>
          </div>
          <div className="flex min-w-[4.5rem] shrink-0 justify-end">
            {props.trailing ?? <span className="inline-block" aria-hidden />}
          </div>
        </div>
        <div className="min-h-0 flex-1 overflow-auto px-3 py-3">
          {props.children}
        </div>
        {props.footer ? (
          <div className="shrink-0 border-t border-[var(--color-border)] px-3 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
            {props.footer}
          </div>
        ) : (
          <div className="shrink-0 pb-[max(0.75rem,env(safe-area-inset-bottom))]" />
        )}
      </DialogContent>
    </Dialog>
  );
}
